<script>
import vue2Dropzone from "vue2-dropzone";
import {
    ArrowUpIcon,
    FacebookIcon,
    CheckCircleIcon,
    RefreshCcwIcon,
    SmartphoneIcon,
    TabletIcon,
    KeyIcon,
    InstagramIcon,
    TwitterIcon,
    ShoppingCartIcon,
    ShoppingBagIcon,
    LinkedinIcon,
    GithubIcon,
    ListIcon,
    YoutubeIcon,
    GitlabIcon,
    MailIcon,
    UserPlusIcon,
    UserIcon,
    EditIcon,
    AwardIcon,
    UsersIcon,
  MessageCircleIcon,
    BellIcon,
    ToolIcon,
    PhoneIcon,
    BookmarkIcon,
    ItalicIcon,
    GlobeIcon,
    GiftIcon,
    MapPinIcon
} from 'vue-feather-icons';

import Navbar from "@/components/navbar";
import Footer from "@/components/footer";

import config from "@/config.json";
import axios from 'axios';
import {avatarUrl, host, post} from "@/assets/js/utils";
/**
 * Account-profile component
 */
export default {
    data() {
      const accessToken = localStorage.getItem("access_token");

      return {
          avatarHost: avatarUrl(),
          user: {
            email: "",
            avatar: "",
            name: "",
            status: 1,
            phone: "",
            org_id: -1
          },
          page: 'info',
          tabs: ['info', 'profit', 'order', 'device', 'setting', 'logout'],
          tabIcons: ['uil-user', 'uil-award', 'uil-shopping-cart', 'uil-tablet', 'uil-users-alt', 'uil-setting', 'uil-sign-out-alt'],
          profits: [ ],
          authMap: ['auth_trial', 'auth_subscribe', 'auth_lifetime', 'auth_expired'],
          authStyleMap: ['badge-warning', 'badge-success', 'badge-success', 'badge-danger'],
          orders: [ ],
          devices: [ ],
          editDevice:
              {
            mac: "xx:xx:xx:xx",
            name: "",
          },
        show_email_edit: -1,
        email_editing: -1,
        show_password_edit: -1,
        password_editing: -1,
        member_uid: 0,
        member_email: "",
        member_password: "",
        enterprise: {
            org_id: -1,
          org_name: "",
          quota: 0,
          quota_used: 0,
          members: [
            {
              uid: 0,
              email: "",
              password: "",
              last_access: ""
            }
          ]
        },
          avatar_page: 0,
          avatar_index: -1,
          uploadStatus: 0,
          dropzoneOptions: {
            url: `${process.env.VUE_APP_SERVER_HOST}${config.api.uploadavatar}`, //"http://127.0.0.1/api/upload-avatar",
            thumbnailWidth: 150,
            maxFilesize: 1,
            withCredentials: true,
            thumbnailMethod: "contain",
            acceptedFiles: "image/*",
            headers: {
              'Authorization': `Bearer ${accessToken}`
            }
          },
          updateStatus: 0,
          updateMessage: "",
          password: "",
          password_repeat: "",
          validation: {
            status: 0,
            code: "",
          }
        }
    },
  mounted() {
    this.getUserInfo();
    const pages = ["#info", "#profit", "#order", "#devices", "#setting"];
      if (location.hash !== '') {
        const idx = pages.indexOf(location.hash);
        if (idx > -1) {
          this.switchPage(idx);
        }
      }
  },
  methods: {
    showFollowModal() {
      this.$bvModal.show("ticket-modal1");
    },
      switchPage(p) {
        const tabs = ['info', 'profit', 'order', 'device', 'enterprise', 'setting', 'logout'];
        this.page = p;
        switch (p) {
          case 'info': this.getUserInfo(); break;
          case 'profit': this.getProfits(); break;
          case 'order': this.getOrders(); break;
          case 'device': this.getDevices(); break;
          case 'enterprise': this.getEnterpriseInfo(); break;
          case 'setting': this.getUserInfo(); break;
          case 'logout': this.logout(); break;
        }
      },
    async logout() {
      try {
        const data = await post(`${config.api.logout}`, {redirect: config.webHost});
        if (data.errno === 0) {
          localStorage.removeItem("access_token");
          localStorage.removeItem("access_key");
          await this.$router.push('/');
        }
      } catch (e) {}
    },
      async getUserInfo() {
        try {
          const data = await post(`${config.api.userinfo}`, {});
          if (data.errno === 0) {
            this.isLogin = true;
            this.user = data;
            if (this.user.org_id > -1) {
              this.tabs= ['info', 'profit', 'order', 'device', 'enterprise', 'setting', 'logout'];
            }
          } else {
            if (data.errno === 12) {
              await this.$router.push('/');
            }
          }
        } catch (e) {}
      },
    async getProfits() {
      try {
        const data = await post(`${config.api.profits}`, {});
        if (data.errno === 0) {
          this.profits = data.list;
        }
      } catch (e) {}
    },
    async getOrders() {
      try {
        const data = await post(`${config.api.orders}`, {});
        if (data.errno === 0) {
          this.orders = data.list;
        }
      } catch (e) {}
    },
    async removeOrder(order_id) {
      try {
        const data = await post(`${config.api.deleteorder}`, {order_id});
        if (data.errno === 0) {
          await this.getOrders();
        }
      } catch (e) {}
    },
    async getDevices() {
      try {
        const data = await post(`${config.api.devices}`, {});
        if (data.errno === 0) {
          this.devices = data.list;
        }
      } catch (e) {}
    },
    async removeDevice(mac) {
      try {
        const data = await post(`${config.api.removedevice}`, {mac});
        if (data.errno === 0) {
          setTimeout(() => this.getDevices(), 200);
        }
      } catch (e) {}
    },
    async updateDeviceName() {
        if (!/^[a-z0-9\\-_\\.@#]+$/.test(this.editDevice.name)) {
          alert(this.$t('profile.device.format_error'));
          return;
        }
      try {
          const {mac, name} = this.editDevice;
        const data = await post(`${config.api.updatedevice}`, {mac, name});
        if (data.errno === 0) {
          setTimeout(() => this.getDevices(), 200);
        }
      } catch (e) {}
    },
    async getEnterpriseInfo() {
      try {
        const data = await post(`${config.api.enterpriseinfo}`, {org_id: this.user.org_id});
        if (data.errno === 0) {
          this.enterprise = data;
        }
      } catch (e) {}
    },
    async updateEnterpriseName() {
      try {
        if (this.enterprise.org_name.trim() === '') {
          return;
        }
        const data = await post(`${config.api["update-enterprise"]}`, {org_id: this.enterprise.org_id, org_name: this.enterprise.org_name});
        if (data.errno === 0) {
          await this.getEnterpriseInfo();
        }
      } catch (e) {}
    },
    async updateMemberInfo() {
      if (this.member_email.trim() === '' && this.member_password.trim() === '') {
        return;
      }
      const params = { uid: this.member_uid}
      if (this.member_email.trim() !== '') {
        params.email = this.member_email;
      }
      if (this.member_password.trim() !== '') {
        params.password = this.member_password;
      }
      try {
        const data = await post(`${config.api["update-member"]}`, params);
        if (data.errno === 0) {
          this.email_editing = -1;
          this.password_editing = -1;
          this.member_email = '';
          this.member_password = '';
          await this.getEnterpriseInfo();
        }
      } catch (e) {}
    },
    async addQuota() {
      try {
        const data = await post(`${config.api.neworder}`, {sku_id: 21});
        if (data.errno === 0) {
          const order_id = data.data.order_id;
          await this.$router.push('/shop-cart?order_id=' + order_id);
        }
      } catch (e) {}
    },
    async onSelectAvatar() {
        if (this.avatar_index === -1) { return; }
        const avatar = `anonymous_icon_${this.avatar_index + 1}.png@2x.png`;
        try {
          const data = await post(`${config.api.updateuser}`, {avatar});
          if (data.errno === 0) {
            this.user.avatar = this.avatarHost +  avatar;
          }
        } catch (e) {

        }
    },
    async updateUserInfo() {
      try {
        const {email, phone, name} = this.user;
        const data = await post(`${config.api.updateuser}`, {email, phone, name});
        if (data.errno === 0) {
          this.updateStatus = 1;
          setTimeout(() => this.updateStatus = 0, 2000);
          await this.getUserInfo();
        } else {
          this.updateStatus = 3;
          this.updateMessage = data.info;
          setTimeout(() => this.updateStatus = 0, 5000);
        }
      } catch (e) {
      }
    },
    async updatePassword() {
      try {
        if (this.password.trim() === "" || this.password_repeat.trim() === "" || this.password !== this.password_repeat) {
          return;
        }
        if (this.password.length < 6) {
          return;
        }
        const data = await post(`${config.api.updateuser}`, {password: this.password});
        if (data.errno === 0) {
          this.updateStatus = 2;
          this.password = this.password_repeat = "";
          setTimeout(() => this.updateStatus = 0, 2000);
        }
      } catch (e) {
      }
    },
    async sendEmailValidationCode() {
      try {
        const {email} = this.user;
        const data = await post(`${config.api.resend}`, {email, type: 1, app: "Design Mirror"});
        if (data.errno === 0) {
          this.validation.status = 1;
        }
      } catch (e) {
      }
    },
    async updateUserStatus() {
      if (this.validation.code.trim() === "") {
        return;
      }
      try {
        const data = await post(`${config.api.verify}`, {email: this.user.email, code: this.validation.code, type: 1});
        if (data.errno === 0) {
          this.validation.status = 2;
          setTimeout(() => {
            this.getUserInfo();
          }, 200);
        }
      } catch (e) {
      }
    },
    onAvatarUploadSuccess(file, response) {
        if (response.errno === 0) {
          this.uploadStatus = 1;
          this.user.avatar = this.avatarHost + response.avatar;
        }
    },
    onAvatarError(file, message, xhr) {
        this.uploadStatus = 2;
        console.log(message);
    },
  },
    components: {
        Navbar,
        Footer,
        ArrowUpIcon,
      vueDropzone: vue2Dropzone,
        FacebookIcon,
      CheckCircleIcon,
      RefreshCcwIcon,
        InstagramIcon,
      SmartphoneIcon,
      TabletIcon,
      KeyIcon,
        TwitterIcon,
        LinkedinIcon,
      ShoppingCartIcon,
      ShoppingBagIcon,
        GithubIcon,
      ListIcon,
        YoutubeIcon,
        GitlabIcon,
        MailIcon,
        UserPlusIcon,
        UserIcon,
      EditIcon,
      AwardIcon,
      UsersIcon,
        MessageCircleIcon,
        BellIcon,
        ToolIcon,
        PhoneIcon,
        BookmarkIcon,
        ItalicIcon,
        GlobeIcon,
        GiftIcon,
        MapPinIcon
    }
}
</script>

<template>
<div>
    <Navbar :nav-light="true" />

    <!-- Hero Start -->
    <section class="bg-profile d-table w-100 bg-primary" style="background: url('images/account/bg.png') center center;">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="card public-profile border-0 rounded shadow" style="z-index: 1;">
                        <div class="card-body">
                            <div class="row align-items-center">
                                <div class="col-lg-2 col-md-3 text-md-left text-center">
                                    <img :src="user.avatar" class="avatar avatar-large rounded-circle shadow d-block mx-auto" alt="">
                                </div>
                                <!--end col-->

                                <div class="col-lg-10 col-md-9">
                                    <div class="row align-items-end">
                                        <div class="col-md-7 text-md-left text-center mt-4 mt-sm-0">
                                            <h3 class="title mb-0">{{user.name}}</h3>
                                            <small class="text-muted h6 mr-2">{{user.email}}</small>
                                            <div v-if="user.status === 0 && page !== 4" class="alert alert-warning" role="alert" v-html="$t('profile.email_invalid')">  </div>
                                        </div>
                                        <!--end col-->
                                        <div class="col-md-5 text-md-right text-center"> </div>
                                        <!--end col-->
                                    </div>
                                    <!--end row-->
                                </div>
                                <!--end col-->
                            </div>
                            <!--end row-->
                        </div>
                    </div>
                </div>
                <!--end col-->
            </div>
            <!--end row-->
        </div>
        <!--ed container-->
    </section>
    <!--end section-->
    <!-- Hero End -->

    <!-- Profile Start -->
    <section class="section mt-60">
        <div class="container mt-lg-3">
            <div class="row">
                <div class="col-lg-4 col-md-6 col-12 d-lg-block d-none">
                    <div class="sidebar sticky-bar p-4 rounded shadow">

                        <div class="widget">
                            <div class="row">
                                <div class="col-6 mt-4 pt-2" v-for="(item ,index) in tabs">
                                    <a href="#" @click.prevent="switchPage(item)" class="accounts rounded d-block shadow text-center py-3" :class="{'active': page === item}">
                                        <span class="pro-icons h3 text-muted"><i class="uil" :class=[tabIcons[index]]></i></span>
                                        <h6 class="title text-dark h6 my-0">{{$t('profile.'+ item +'.title')}}</h6>
                                    </a>
                                </div>
                                <!--end col-->
                            </div>
                            <!--end row-->
                        </div>
                    </div>
                </div>
                <!--end col-->

                <div class="col-lg-8 col-12" v-if="page === 'info'">
                    <div class="border-bottom pb-4">
                        <h5>{{$t('profile.info.title')}}</h5>
                        <p class="text-muted mb-0" v-html="$t('profile.info.description')"></p>
                    </div>

                    <div class="border-bottom pb-4">
                        <div class="row">
                            <div class="col-md-10 mt-4">
                                <div class="mt-4">
                                    <div class="media align-items-center">
                                        <mail-icon class="fea icon-ex-md text-muted mr-3"></mail-icon>
                                        <div class="media-body">
                                            <h6 class="text-primary mb-0">{{$t('profile.info.email')}}</h6>
                                            <a href="javascript:void(0)" class="text-muted">{{user.email}}</a>
                                        </div>
                                    </div>
                                    <div class="media align-items-center mt-3">
                                        <bookmark-icon class="fea icon-ex-md text-muted mr-3"></bookmark-icon>
                                        <div class="media-body">
                                            <h6 class="text-primary mb-0">{{$t('profile.info.status.title')}}</h6>
                                          <span v-if="user.status === 0" class="badge badge-warning badge-pill">{{$t('profile.info.status.non_active')}}</span>
                                          <span v-if="user.status === 0" class="text-muted ml-2">{{$t('profile.info.status.non_active_tip')}}</span>
                                          <span v-if="user.status === 1" class="badge badge-success badge-pill">{{$t('profile.info.status.active')}}</span>
                                          <span v-if="user.status === 2" class="badge badge-danger badge-pill">{{$t('profile.info.status.block')}}</span>
                                          <span v-if="user.status === 2" class="text-muted ml-2">{{$t('profile.info.status.block_tip')}}</span>
                                        </div>
                                    </div>
                                    <div class="media align-items-center mt-3">
                                        <italic-icon class="fea icon-ex-md text-muted mr-3"></italic-icon>
                                        <div class="media-body">
                                            <h6 class="text-primary mb-0">{{$t('profile.info.name')}}</h6>
                                            <a href="javascript:void(0)" class="text-muted">{{user.name}}</a>
                                        </div>
                                    </div>
                                    <div class="media align-items-center mt-3">
                                        <phone-icon class="fea icon-ex-md text-muted mr-3"></phone-icon>
                                        <div class="media-body">
                                            <h6 class="text-primary mb-0">{{$t('profile.info.phone')}}</h6>
                                            <span v-if="user.phone === ''" class="badge badge-warning badge-pill">{{$t('profile.info.no_phone')}}</span>
                                          <span v-if="user.phone === ''" class="text-muted ml-2">{{$t('profile.info.no_phone_tip')}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!--end col-->

                            <div class="col-md-6 mt-4 pt-2 pt-sm-0">
                            </div>
                            <!--end col-->
                        </div>
                        <!--end row-->
                    </div>

                </div>
                <!--end info-->

              <div class="col-lg-8 col-12" v-if="page === 'profit'">
                <div class="border-bottom pb-4">
                  <h5>{{$t('profile.profit.title')}}</h5>
                  <p class="text-muted mb-0" v-html="$t('profile.profit.description')"></p>
                </div>

                <div class="border-bottom pb-4">
                  <div class="table-responsive bg-white shadow rounded">
                    <table class="table mb-0 table-center table-nowrap">
                      <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">{{$t('profile.profit.app')}}</th>
                        <th scope="col">{{$t('profile.profit.auth_status')}}</th>
                        <th scope="col">{{$t('profile.profit.end_time')}}</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item,idx) in profits">
                        <th scope="row">{{++idx}}</th>
                        <td><span class="badge badge-outline-secondary">{{item.app}}</span></td>
                        <td>
                          <span class="badge badge-pill" :class=[authStyleMap[item.auth_status]]> {{$t('profile.profit.' + authMap[item.auth_status])}} </span>
                        </td>
                        <td v-if="item.end_time !== ''"> {{item.end_time | formatDate}} </td>
                        <td v-else></td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!--end profit-->

              <div class="col-lg-8 col-12" v-if="page === 'order'">
                <div class="border-bottom pb-4">
                  <h5>{{$t('profile.order.title')}}</h5>
                  <p class="text-muted mb-0">{{$t('profile.order.description')}} <a href="#" @click.prevent="showFollowModal">{{$t('profile.order.ticket')}}</a></p>
                </div>

                <div class="border-bottom pb-4">
                  <div class="table-responsive bg-white shadow rounded">
                    <table class="table mb-0 table-center table-nowrap">
                      <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">{{$t('profile.order.name')}}</th>
                        <th scope="col">{{$t('profile.order.price')}}</th>
                        <th scope="col">{{$t('profile.order.status')}}</th>
                        <th scope="col">{{$t('profile.order.created_at')}}</th>
                        <th scope="col">{{$t('profile.order.operation')}}</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item,idx) in orders">
                        <th scope="row">{{++idx}}</th>
                        <td>{{item.name}}</td>
                        <td>{{item.price}}</td>
                        <td> <span class="badge badge-pill" :class="{'badge-soft-info': item.trade_status === 1, 'badge-soft-dark': item.trade_status !== 1}"> {{$t('profile.order.status_' + item.trade_status)}} </span> </td>
                        <td> {{item.updated_at | formatDate2}} </td>
                        <td>
                          <a class="badge badge-pill badge-blue" v-if="item.trade_status === 0 ||item.trade_status === 2 " :href="'/shop-cart?order_id='+item.order_id">{{$t('profile.order.pay')}}</a>
                          <a class="badge badge-pill badge-warning ml-2" v-if="item.trade_status === 0 ||item.trade_status === 2 " href="#" @click.prevent="removeOrder(item.order_id)">{{$t('profile.order.delete')}}</a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <b-modal id="ticket-modal1" size="sm" ref="ticket-modal" hide-footer
                         :title="$t('profile.order.ticket_title')"
                         header-close-variant="white"
                         no-close-on-backdrop
                         header-class="border-0"
                         content-class="border-0" centered >
                  <div>
                    <p>{{$t('profile.order.ticket_detail')}}</p>
                    <img src="images/index/wechat_qrcode_20240129.jpg" class="img-fluid" alt="">
                  </div>
                </b-modal>
              </div>
              <!--end order-->

              <div class="col-lg-8 col-12" v-if="page === 'device'">
                <div class="border-bottom pb-4">
                  <h5>{{$t('profile.device.title')}}</h5>
                  <p class="text-muted mb-0" v-html="$t('profile.device.description')"></p>
                </div>

                <div class="border-bottom pb-4">
                  <div class="table-responsive bg-white shadow rounded">
                    <table class="table mb-0 table-center table-nowrap">
                      <thead>
                      <tr>
                        <th scope="col">{{$t('profile.device.mac')}}</th>
                        <th scope="col">{{$t('profile.device.os')}}</th>
                        <th scope="col">App/{{$t('profile.device.created_at')}}</th>
                        <th scope="col">{{$t("profile.device.name")}}</th>
                        <th scope="col">{{$t('profile.device.op')}}</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item,idx) in devices">
                        <td><span class="badge badge-pill badge-dark">{{item.mac}}</span><br/> <span class="badge badge-pill badge-outline-light"> {{item.ip}}</span></td>
                        <td>{{item.os}}</td>
                        <td>{{item.app}}<br/>{{item.created_at | formatDate}} </td>
                        <td>{{item.name}} <a href="#" @click.prevent="editDevice.name = item.name; editDevice.mac = item.mac" v-b-modal.modal2 class="ml-1 text-primary"><i class="uil uil-edit-alt"></i></a> </td>
                        <td> <a href="#" v-b-modal.modal2 @click.prevent="removeDevice(item.mac)" class="text-primary" >{{$t('profile.device.remove')}}</a> </td>
                      </tr>
                      </tbody>
                    </table>

                    <b-modal id="modal2" ref="modal2" @ok="updateDeviceName" :cancel-title="$t('profile.setting.select_cancel')" :ok-title="$t('profile.device.modal_ok')" :title="$t('profile.device.modal_title')" header-close-variant="white" header-class="border-0" content-class="border-0" centered >
                      <div class="row">
                        <p class="ml-3">{{$t('profile.device.name_tip')}}</p>
                        <div class="col-5">
                          <div class="form-group">
                            <input type="text" class="form-control" v-model="editDevice.name" />
                          </div>
                        </div>
                      </div>
                    </b-modal>

                  </div>
                </div>
              </div>
              <!--end device-->


              <div class="col-lg-8 col-12" v-if="page === 'enterprise'">
                <div class="border-bottom pb-4">
                  <h5>{{$t('profile.enterprise.title')}}</h5>
                  <p class="text-muted mb-0" v-html="$t('profile.enterprise.description')"></p>
                </div>

                <div class="border-bottom pb-4">
                  <div class="card mb-4">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>{{$t('profile.enterprise.name')}}</label>
                            <div class="position-relative">
                              <users-icon class="fea icon-sm icons"></users-icon>
                              <input v-model="enterprise.org_name" name="name" type="text" class="form-control pl-5" />
                            </div>
                            <a href="#" @click.prevent="updateEnterpriseName" class="mt-3 btn btn-primary btn-sm"> {{$t('profile.enterprise.save')}} </a>
                          </div>
                        </div>
                        <!--end col-->
                        <div class="col-md-6">
                          <!--
                          <div class="form-group">
                            <label>{{$t('profile.enterprise.quota')}}</label>
                            <div class="position-relative">
                              <shopping-bag-icon class="fea icon-sm icons"></shopping-bag-icon>
                              <input name="name" type="text" class="form-control pl-5" :value="enterprise.quota_used + '/' + enterprise.quota" disabled="disabled" />
                            </div>
                            <a href="#" @click.prevent="addQuota" class="mt-3 btn btn-info btn-sm"> {{$t('profile.enterprise.add_quota')}} </a>
                          </div>
                          -->
                        </div>
                        <!--end col-->
                      </div>
                    </div>
                  </div>
                </div>

                <div class="border-bottom pb-4">
                  <h5>{{$t('profile.enterprise.members')}}</h5>
                  <div class="table-responsive bg-white shadow rounded">
                    <table class="table mb-0 table-center table-nowrap">
                      <thead>
                      <tr>
                        <th scope="col">{{$t('profile.enterprise.email')}}</th>
                        <th scope="col">{{$t('profile.enterprise.password')}}</th>
                        <th scope="col">{{$t('profile.enterprise.last_access_time')}}</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item,idx) in enterprise.members">
                        <td @mouseover="show_email_edit = idx">
                          <div v-if="email_editing !== idx">
                            <span>{{item.email}}</span>
                            <a v-show="show_email_edit === idx" href="#" @click.prevent="email_editing=idx;member_uid=item.uid; member_email=item.email"><edit-icon class="fea icon-sm ml-2"></edit-icon></a>
                          </div>
                          <div class="form-group" v-if="email_editing === idx">
                            <div class="position-relative">
                              <mail-icon class="fea icon-sm icons"></mail-icon>
                              <input class="form-control pl-5" type="text" v-model="member_email" />
                            </div>
                            <a href="#" @click.prevent="updateMemberInfo" class="mt-3 btn btn-primary btn-sm"> {{$t('profile.enterprise.save')}} </a>
                            <a href="#" @click.prevent="email_editing = -1" class="mt-3 btn btn-outline-light btn-sm ml-3">{{$t('profile.enterprise.cancel')}}</a>
                          </div>
                        </td>
                        <td @mouseover="show_password_edit = idx">
                          <div v-if="password_editing !== idx">
                            <span>{{item.password}}</span>
                            <a v-show="show_password_edit === idx" href="#" @click.prevent="password_editing=idx;member_uid=item.uid; member_password=item.password"><edit-icon class="fea icon-sm ml-2"></edit-icon></a>
                          </div>
                          <div class="form-group" v-if="password_editing === idx">
                            <div class="position-relative">
                              <mail-icon class="fea icon-sm icons"></mail-icon>
                              <input width="100" class="form-control pl-5" type="text" v-model="member_password" />
                            </div>
                            <a href="#" @click.prevent="updateMemberInfo" class="mt-3 btn btn-primary btn-sm"> {{$t('profile.enterprise.save')}} </a>
                            <a href="#" @click.prevent="password_editing=-1" class="mt-3 btn btn-outline-light btn-sm ml-3">{{$t('profile.enterprise.cancel')}}</a>
                          </div>
                        </td>
                        <td>{{item.last_access !== ''? (item.last_access | formatDate) : '-'}} </td>
                      </tr>
                      </tbody>
                    </table>

                    <b-modal id="modal2" ref="modal2" @ok="updateDeviceName" :cancel-title="$t('profile.setting.select_cancel')" :ok-title="$t('profile.device.modal_ok')" :title="$t('profile.device.modal_title')" header-close-variant="white" header-class="border-0" content-class="border-0" centered >
                      <div class="row">
                        <p class="ml-3">{{$t('profile.device.name_tip')}}</p>
                        <div class="col-5">
                          <div class="form-group">
                            <input type="text" class="form-control" v-model="editDevice.name" />
                          </div>
                        </div>
                      </div>
                    </b-modal>

                  </div>

                </div>
              </div>
              <!--end device-->

              <div class="col-lg-8 col-12" v-if="page === 'setting'">
                <div class="pb-4">
                  <h5>{{$t('profile.setting.title')}}</h5>
                </div>

                <div class="border-bottom pb-4">

                  <div class="card mb-4" v-if="user.status === 0">
                    <div class="card-body">
                      <div class="alert alert-warning" role="alert"> {{$t('profile.setting.email_validate_tip')}}</div>
                      <h5>{{$t('profile.setting.email_validate')}} </h5>
                      <div class="mt-2" v-if="validation.status === 0">
                        <span>{{user.email}}</span>
                        <a href="#" @click.prevent="sendEmailValidationCode" class="btn btn-sm btn-primary ml-2">{{$t('profile.setting.send_code')}}</a>
                      </div>
                      <div class="mt-2 row" v-if="validation.status > 0">
                        <div class="ml-2 mb-2" v-html="$t('profile.setting.code_input_tip', {email: user.email})"></div>
                        <div class="col-4">
                          <div class="form-group">
                            <input v-model="validation.code" type="text" name="code" class="form-control" />
                          </div>
                        </div>
                        <div class="col-8">
                          <a href="#" @click.prevent="updateUserStatus" class="btn btn-primary">{{$t('profile.setting.code_submit')}}</a>
                          <a href="#" @click.prevent="sendEmailValidationCode" class="btn btn-icon btn-pills btn-outline-primary ml-3"><refresh-ccw-icon class="fea icon-sm"></refresh-ccw-icon></a>
                          <check-circle-icon v-if="validation.status === 2" class="fea icon-m-md icons ml-2 text-success"></check-circle-icon>
                        </div>
                      </div>

                    </div>
                  </div>


                  <div class="card">
                    <div class="card-body">
                      <form @submit.prevent="updateUserInfo">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label>{{$t('profile.setting.email')}}</label>
                              <span class="badge badge-pill badge-info ml-2">{{$t('profile.setting.email_tip')}}</span>
                              <div class="position-relative">
                                <mail-icon class="fea icon-sm icons"></mail-icon>
                                <input name="email" id="email" type="email" class="form-control pl-5" v-model="user.email" />
                              </div>
                            </div>
                          </div>
                          <!--end col-->
                          <div class="col-md-6">
                            <div class="form-group">
                              <label>{{$t('profile.setting.name')}}</label>
                              <div class="position-relative">
                                <user-icon class="fea icon-sm icons"></user-icon>
                                <input name="name" id="display-name" type="text" class="form-control pl-5" v-model="user.name" />
                              </div>
                            </div>
                          </div>
                          <!--end col-->
                          <div class="col-md-6">
                            <div class="form-group">
                              <label>{{$t('profile.setting.phone')}}</label>
                              <div class="position-relative">
                                <phone-icon class="fea icon-sm icons"></phone-icon>
                                <input name="name" id="first-name" type="text" class="form-control pl-5" v-model="user.phone" />
                              </div>
                            </div>
                          </div>
                          <!--end col-->
                          <div class="col-md-6">
                            <div class="form-group">
                              <label>{{$t('profile.setting.avatar')}}</label>
                              <div class="position-relative">
                                <img :src="user.avatar" alt="" width="40" />
                                <a href="javascript:void(0)" v-b-modal.modal class="ml-2 btn btn-light btn-sm"><i class="uil uil-list-ul"></i> {{$t("profile.setting.select_avatar")}}</a>
                                <a href="javascript:void(0)" v-b-modal.modal1 class="ml-2 btn btn-light btn-sm"><i class="uil uil-image-upload"></i> {{$t("profile.setting.upload_avatar")}}</a>
                              </div>
                            </div>
                          </div>
                          <!--end col-->

                          <!-- select avatar modal -->
                          <b-modal id="modal" size="lg" @ok="onSelectAvatar" :cancel-title="$t('profile.setting.select_cancel')" :ok-title="$t('profile.setting.select_done')" :title="$t('profile.setting.select_avatar')" header-close-variant="white" header-class="border-0" content-class="border-0" centered >
                            <div class="row">
                              <div class="col-lg-2 mt-3" v-for="(item, index) in new Array(24)">
                                <a href="#" class="accounts rounded d-block shadow text-center py-3" @click.prevent="avatar_index = avatar_page*24+index" :class="{'active': avatar_index === avatar_page*24+index}">
                                  <img :src="'https://cutterman.oss-cn-shanghai.aliyuncs.com/static/images/avatar/anonymous_icon_'+(avatar_page*24+index+1)+'.png@2x.png'" alt="" width="60" />
                                </a>
                              </div>
                            </div>
                            <div class="row mt-3">
                              <div class="col-8">
                                <ul class="pagination mb-0 ml-2">
                                  <li class="page-item" v-for="(item, index) in new Array(8)" :class="{'active': avatar_page === index}">
                                    <a class="page-link" href="#" @click.prevent="avatar_page = index">{{index+1}}</a>
                                  </li>
                                </ul>
                              </div>
                              <div class="col-4 text-right">
                              </div>
                            </div>
                          </b-modal>
                          <!-- select avatar modal end -->

                          <b-modal id="modal1" ref="modal1" @show="uploadStatus=0" :cancel-title="$t('profile.setting.select_cancel')" :ok-title="$t('profile.setting.upload')" :title="$t('profile.setting.upload_avatar')" header-close-variant="white" header-class="border-0" content-class="border-0" centered >
                            <div class="row">
                              <div class="col-12">
                                <div class="card shadow rounded border-0 overflow-hidden text-center">
                                  <vue-dropzone
                                      id="customdropzone"
                                      ref="myVueDropzone"
                                      @vdropzone-success="onAvatarUploadSuccess"
                                      @vdropzone-error="onAvatarError"
                                      :include-styling="false"
                                      :use-custom-slot="true"
                                      :options="dropzoneOptions" >
                                    <div class="dropzone-custom-content" v-show="uploadStatus === 0">
                                      <i class="uil uil-image-upload display-2 mb-2"></i>
                                      <h5>{{$t('profile.setting.upload_tip')}}</h5>
                                    </div>
                                  </vue-dropzone>
                                </div>
                              </div>
                            </div>
                          </b-modal>

                          <div class="col-lg-12 mt-2 mb-0">
                            <button class="btn btn-primary">{{$t('profile.setting.save')}}</button>
                            <check-circle-icon v-if="updateStatus === 1" class="fea icon-m-md icons ml-2 text-success"></check-circle-icon>
                            <span v-if="updateStatus === 3" class="badge badge-pill badge-danger ml-2">{{updateMessage}}</span>
                          </div>
                          <!--end col-->
                        </div>
                        <!--end row-->
                      </form>
                    </div>
                  </div>


                  <h5 class="mt-4">{{$t('profile.setting.change_password')}} </h5>
                  <p><span class="badge badge-info badge-pill ml-2">{{$t("profile.setting.password_info")}}</span></p>
                  <form @submit.prevent="updatePassword">
                    <div class="row mt-3">
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label>{{$t('profile.setting.new_password')}}</label>
                          <div class="position-relative">
                            <key-icon class="fea icon-sm icons"></key-icon>
                            <input v-model="password" type="password" class="form-control pl-5" :placeholder="$t('profile.setting.password_tip')" required="" />
                          </div>
                        </div>
                      </div>
                      <!--end col-->

                      <div class="col-lg-12">
                        <div class="form-group">
                          <label>{{$t('profile.setting.new_password_repeat')}}</label>
                          <div class="position-relative">
                            <key-icon class="fea icon-sm icons"></key-icon>
                            <input v-model="password_repeat" type="password" class="form-control pl-5" :placeholder="$t('profile.setting.password_tip')" required="" />
                          </div>
                        </div>
                      </div>
                      <!--end col-->

                      <div class="col-lg-12 mt-2 mb-0">
                        <button class="btn btn-primary">{{$t('profile.setting.save_password')}}</button>
                        <check-circle-icon v-if="updateStatus === 2" class="fea icon-m-md icons ml-2 text-success"></check-circle-icon>
                      </div>
                      <!--end col-->
                    </div>
                    <!--end row-->
                  </form>

                </div>
              </div>
              <!--end setting-->



            </div>
          <!--end row-->
        </div>
        <!--end container-->
    </section>
    <!--end section-->
    <!-- Profile End -->
    <!--end section-->
    <Footer />
    <!-- Footer End -->
    <!-- Back to top -->
    <a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" v-scroll-to="'#topnav'">
        <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
</div>
</template>

<style>
#customdropzone {
  background-color: #eee;
  font-family: 'Arial', sans-serif;
  letter-spacing: 0.2px;
  color: #777;
  transition: background-color .2s linear;
  height: 200px;
  padding: 40px;
}

#customdropzone .dz-preview {
  display: inline-block;
  text-align: center;
}
#customdropzone .dz-preview .dz-image {
  width: 80px;
  height: 80px;
  margin: 0 auto;
}
#customdropzone .dz-preview .dz-image > div {
  width: inherit;
  height: inherit;
  border-radius: 50%;
  background-size: contain;
}
#customdropzone .dz-preview .dz-image > img {
  width: 100%;
}

#customdropzone .dz-error-message {
  color: orangered;
}

#customdropzone .dz-preview .dz-details {
  color: #333;
  transition: opacity .2s linear;
  text-align: center;
}
#customdropzone .dz-success-mark, .dz-error-mark, .dz-remove {
  display: none;
}
</style>
